export default {
  mounted () {
  },
  data() {
    return {
      visibleMenu: false
    }
  }
}
